import React from 'react';
import './LoadingTemplate.scss';
import { Icons } from '../../utilities';

const LoadingTemplate = props => {
  const { type } = props;
  const colorValue = type === '' ? 'null' : 'white';
  const indicatorClass = type === '' ? 'small' : 'large';
  return (
    <div className='loading-container' style={{ backgroundColor: colorValue }}>
      <div className='d-flex flex-column'>
        <img
          className={indicatorClass}
          src={Icons.loading}
          alt=''
          id='loading'
        />
        <label htmlFor='loading' className='loading-label'>
          {type}
        </label>
      </div>
    </div>
  );
};

export default LoadingTemplate;
